module.exports = __webpack_public_path__ + "static/media/starChecked.855efb1f.svg";